"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _getIn = _interopRequireDefault(require("./getIn"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var structure = {
  fromJS: function fromJS(value) {
    return value;
  },
  getIn: _getIn.default,
  merge: function merge(state, payload) {
    return _objectSpread({}, state, payload);
  },
  toJS: function toJS(value) {
    return value;
  }
};
var _default = structure;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/connected-react-router/lib/structure/plain/index.js
// module id = 1209
// module chunks = 0